import { cheatsActions } from './features/cheats/cheats.actions';
import { followingsActions } from './features/followings/followings.actions';
import { gameActions } from './features/game/game.actions';
import { offchainTradingActions } from './features/offchainTrading/offchainTrading.actions';
import { teamActions } from './features/teams/teams.actions';

export const actions = {
  ...gameActions,
  ...teamActions,
  ...offchainTradingActions,
  ...followingsActions,
  ...(process.env.STAGE !== 'prod'
    ? cheatsActions
    : ({} as typeof cheatsActions)),
};

export default actions;
